import { render, staticRenderFns } from "./PmSvg.vue?vue&type=template&id=fe530f7c&"
var script = {}
import style0 from "./PmSvg.vue?vue&type=style&index=0&id=fe530f7c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports